<template>
    <div>
        <div class="pt-5">
            <div class="tab-container">
                <div
                    :class="{ 'active': tab === 'fulltime' }"
                    class="full-time locale-font"
                    @click="updateTab('fulltime')">
                    {{ $vuetify.lang.t('$vuetify.leaveQuota.fullTimeLeave') }}
                </div>
                <div
                    :class="{ 'active': tab === 'probation' }"
                    class="probation locale-font"
                    @click="updateTab('probation')">
                    {{ $vuetify.lang.t('$vuetify.leaveQuota.probation') }}
                </div>
            </div>
            <div class="leave-quota-content">
                <v-container>
                    <v-row>
                        <v-col cols="12">
                            <div class="leave-topic locale-font">
                                {{ leaveTypeText }}
                                <v-container>
                                    <v-form
                                        lazy-validation
                                        ref="form">
                                        <v-row>
                                            <v-col
                                                class="pl-0"
                                                cols="3">
                                                <v-text-field
                                                    :label="$vuetify.lang.t('$vuetify.leaveQuota.personalLeave')"
                                                    v-mask="'######'"
                                                    v-model="form.personal"
                                                    :rules="inputRules"
                                                    :error-messages="errors.personal">
                                                </v-text-field>
                                            </v-col>
                                            <v-col cols="3">
                                                <v-text-field
                                                    :label="$vuetify.lang.t('$vuetify.leaveQuota.sickLeave')"
                                                    v-mask="'######'"
                                                    v-model="form.sick"
                                                    :rules="inputRules"
                                                    :error-messages="errors.sick">
                                                </v-text-field>
                                            </v-col>
                                            <v-col cols="3">
                                                <v-menu
                                                    v-if="form.employee_employment === 'FTM'"
                                                    v-model="datePickerShow"
                                                    :close-on-content-click="false"
                                                    transition="scale-transition"
                                                    offset-y
                                                    min-width="234px">
                                                    <template v-slot:activator="{ on }">
                                                        <v-text-field
                                                            prepend-inner-icon="event"
                                                            v-model="dateFormatted"
                                                            readonly
                                                            :label="$vuetify.lang.t('$vuetify.leaveQuota.annualResetDate')"
                                                            hint="Date/Month"
                                                            v-on="on"
                                                        ></v-text-field>
                                                    </template>
                                                    <v-date-picker
                                                        :locale="localeLang"
                                                        v-model="date"
                                                        @input="datePickerShow = false">
                                                    </v-date-picker>
                                                </v-menu>
                                            </v-col>
                                        </v-row>
                                    </v-form>
                                </v-container>
                            </div>
                        </v-col>
                    </v-row>
                </v-container>
            </div>
        </div>

        <div class="pt-5 save-changes-container">
            <v-btn
                @click="updateLeaveQuota()"
                color="primary"
                height="40"
                width="264">
                {{ this.$vuetify.lang.t('$vuetify.leaveQuota.saveChanges') }}
            </v-btn>
        </div>
    </div>
</template>

<script>
import { mask } from 'vue-the-mask'

export default {
    name: 'LeaveQuota',

    directives: {
        mask
    },

    data () {
        return {
            tab: 'fulltime', // possible value fulltime, probation
            errors: {},
            date: '',
            dateFormatted: '',
            datePickerShow: false,
            inputRules: [
                v => !!v || 'This field is required'
            ],
            form: {
                personal: 0,
                sick: 0,
                employee_employment: 'FTM', // possible value FTM, PBT
                date: 0,
                month: 0
            }
        }
    },

    computed: {
        localeLang () {
            return this.$vuetify.lang.current
        },
        leaveTypeText () {
            if (this.tab === 'fulltime') {
                return this.$vuetify.lang.t('$vuetify.leaveQuota.fullTimeLeave')
            }
            return this.$vuetify.lang.t('$vuetify.leaveQuota.probationLeave')
        }
    },

    methods: {
        updateTab (newTab) {
            this.tab = newTab
        },

        setDatePicker (date, month) {
            const dateObj = new Date()
            dateObj.setDate(date)
            // month from db is 1 - 12, month for datepicker is 0 - 11
            const monthForDatePicker = month - 1
            dateObj.setMonth(monthForDatePicker)

            this.date = dateObj.toISOString().substr(0, 10)
            this.dateFormatted = this.$util.formatDateMonth(this.date)

            this.setDateStringToForm(this.date)
        },

        setDateStringToForm (dateString) {
            const { date, month } = this.$util.getDateMonthByDateString(dateString)

            this.form.date = date
            this.form.month = month
        },

        async getLeaveQuota () {
            this.$store.dispatch('setLoading', true)
            const url = `leave-quota?employee_employment=${this.form.employee_employment}`
            const res = await this.axios.get(url)
            if (res && res.data && res.data.status === 'ok') {
                const response = res.data.data
                this.form.personal = response.personal
                this.form.sick = response.sick
                this.setDatePicker(response.date, response.month)
                this.$store.dispatch('setLoading', false)
            }
        },

        async updateLeaveQuota () {
            if (!this.$refs.form.validate()) {
                return
            }

            this.$store.dispatch('setLoading', true)

            const form = {
                personal: this.form.personal,
                sick: this.form.sick,
                employee_employment: this.form.employee_employment, // possible value FTM, PBT
                date: this.form.date,
                month: this.form.month
            }

            const res = await this.axios.post('leave-quota/update', form)

            if (res && res.data) {
                if (res.data.status === 'error_inputs') {
                    this.errors = res.data.errors
                    this.$store.dispatch('setLoading', false)
                } else if (res.data.status === 'ok') {
                    this.$store.dispatch('setLoading', false)

                    this.$notify({
                        title: this.$vuetify.lang.t('$vuetify.leaveQuota.congratulation'),
                        text: this.$vuetify.lang.t('$vuetify.leaveQuota.leaveQuotaIsUpdated'),
                        type: 'success'
                    })
                }
            }
        }
    },

    async mounted () {
        await this.getLeaveQuota()
    },

    watch: {
        async tab (newValue, oldValue) {
            if (newValue === 'fulltime') {
                this.form.employee_employment = 'FTM'
                await this.getLeaveQuota()
            } else {
                this.form.employee_employment = 'PBT'
                await this.getLeaveQuota()
            }
        },
        date (newValue, oldValue) {
            this.dateFormatted = this.$util.formatDateMonth(newValue)
            this.setDateStringToForm(newValue)
        }
    }
}
</script>

<style lang="scss" scoped>
.leave-topic {
    font-size: 24px;
}
.tab-container {
    display: flex;
}
.active {
    background-color: #ffffff !important;
    color: #6c98ba !important;
}
.full-time {
    width: 300px;
    height: 50px;
    background-color: #6c98ba;
    border-top-left-radius: 1.25rem;
    border-top-right-radius: 1.25rem;
    color: #ffffff;
    font-size: 20px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
}
.probation {
    width: 300px;
    height: 50px;
    background-color: #6c98ba;
    border-top-left-radius: 1.25rem;
    border-top-right-radius: 1.25rem;
    color: #ffffff;
    font-size: 20px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
}
.leave-quota-content {
    padding: 1rem;
    box-shadow: 0 5px 25px 0 rgba(0, 0, 0, 0.05);
    background-color: #ffffff;
    min-height: 200px;
    border-bottom-left-radius: 1.25rem;
    border-bottom-right-radius: 1.25rem;
    border-top-right-radius: 1.25rem;
}
.save-changes-container {
    display: flex;
    justify-content: flex-end;
}
</style>
